export default "__VITE_ASSET__Deof55n3__"